import { TextContainer } from 'components/container'
import { Video } from 'components/video'
import { Section } from './styled'

export const Intro = () => (
  <Section>
    <TextContainer>
      <p>
        Буряты – коренной народ Восточной Сибири, который проживает на землях вблизи озера Байкал. Сегодня здесь активно возрождают национальные традиции. В этой серии мы расскажем, кто такие современные шаманы. Увидим настоящих костоломов, которые голыми руками разбивают кости. Послушаем песни, которые местные скотоводы поют своим коням. Узнаем, почему не все носители бурятского языка понимают друг друга. А также расскажем, почему так много бурятских мужчин ушли на войну и как это подтолкнуло к созданию одного из ярчайших движений, выступающих против войны и ксенофобии в России.
      </p>

      <Video id="AcgATcdyXWU" poster="https://gdb.currenttime.tv/01000000-0a00-0242-f76b-08dc1dfcf92c.jpg" />
    </TextContainer>
  </Section>
)
